import { BdSdk } from "@blockdaemon/bd-sdk";

let _sdk: BdSdk | undefined;

function getSDK(): BdSdk {
  if (_sdk) {
    return _sdk;
  }

  const preloadedConfig = window.__WIDGET_CONFIG__;
  const referralTag = preloadedConfig?.features?.staking?.referralTag;

  _sdk = new BdSdk({
    basePath: `${window.location.origin}/proxy`,
    ...(referralTag && { configuration: { referralTag } }),
  });

  return _sdk;
}

export const blockdaemonSDK = new Proxy({} as BdSdk, {
  get(_target, prop) {
    const sdk = getSDK();
    // biome-ignore lint/suspicious/noExplicitAny: Proxy requires dynamic property access
    const value = (sdk as any)[prop];
    return typeof value === "function" ? value.bind(sdk) : value;
  },
});
